<template>
  <BlockTemplate
    v-if="hasContent"
    :id="category.slug"
    :no-header="noHeader"
    expandable="opened"
  >
    <template #header>
      <BlockHeader
        ref="header"
        class="header"
        :likable="false"
        :checkable="false"
      >
        {{ category.title }}
      </BlockHeader>
    </template>
    <BlockItemCategory
      v-for="child in category.children"
      :key="child.id"
      :category="child"
    />
    <BlockItemExercise
      v-for="(exercise, index) in exercises"
      :id="exercise.id"
      :key="exercise.id"
      :library-book-id="libraryBookId"
      :index="index"
      :length="exercises.length"
      :is-stars="false"
      :path="exercise.path"
      :score="exercise.score"
      :nb-items-completed="nbItemsCompleted"
      :completed="exercise.completed"
      :previous-completed="exercise.previousCompleted"
      :next-completed="exercise.nextCompleted"
      :text="exercise.text"
      :locked="isTypeExerciseLocked"
      :is-parent-child-page="isParentChildPage"
      :locked-content="exercise.lockedContent"
    />
    <BlockItemPath
      v-for="post in posts"
      :id="post.id"
      :key="post.id"
      :content-type="post.contentType"
      :library-book-id="libraryBookId"
      :icon="post.icon"
      :path="post.path"
      :text="post.title"
      :selectable="false"
      :locked="isTypePostLocked"
      :locked-content="post.contentType"
    />
    <BlockListCategoriesPdfs
      v-if="category.essentialsArray"
      title="Les Essentiels"
      :ids="category.essentialsArray"
      :library-book-id="libraryBookId"
    />
  </BlockTemplate>
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
interface ViewProps {
  category: CategorySchema;
  libraryBookId: string;
  noHeader?: boolean;
}

const props = defineProps({
  category: null,
  libraryBookId: null,
  noHeader: { type: Boolean, default: false }
});

const header = ref<HTMLElement>(null);

const hasContent = computed(
  () => props.category.children.length || props.category.essentialsArray
);

const { isParentChildPage, isTypeExerciseLocked, nbItemsCompleted, exercises } =
  useCategoryBlockExercises(props.category);

const { isTypePostLocked, posts } = useCategoryBlockPosts(props.category);

if (props.category.children.length > 0 && !props.noHeader) {
  useAnchorElement(header, props.category.slug, props.category.title);
}
</script>
